import { useState, useEffect } from 'react';
import TitleBlock from '../TitleBlock/TitleBlock';
import AreaList from '../UI/AreaList/AreaList';
import AreaListData from '../UI/AreaListData/AreaListData';
import FunctionRow from './FunctionRow/FunctionRow';
import { useTreeStateContext } from '../../../contexts/TreeContext';
import { useBotStateContext } from '../../../contexts/BotContext';
import binarySearchString from '../../../utils/binarySearchString';
import { BlockActionFunctionDefault } from '../../../data/constant/blocks/BlockActionFunctionDefault';
import FunctionService from '../../../services/FunctionService';
import editorAction from '../../../actions/editorAction';

function FormFunction({ id }) {
    const { variables } = useBotStateContext();
    const { blocks } = useTreeStateContext();
    const indexBlock = binarySearchString(blocks, id, 'object_id');
    const block = blocks[indexBlock] ? blocks[indexBlock] : BlockActionFunctionDefault;
    const name = block.name;
    const rows = (block.data.functions || []).map((fn, idx) => ({
        ...fn,
        index: fn.index ?? idx,
        value: fn.value ?? fn.call_name ?? fn.functions ?? '',
        params: Array.isArray(fn.params) ? fn.params : (Array.isArray(fn.parameters) ? fn.parameters : []),
        variable: fn.variable ?? (fn.variable_name ? (variables.find(v => v.name === fn.variable_name) ?? null) : null),
    }));

    const [availableFunctions, setAvailableFunctions] = useState([]);
    const { updateBlockData } = editorAction();

    useEffect(() => {
        FunctionService.getFunctions().then(([res, err]) => {
            if (err || !res) return;
            setAvailableFunctions(Array.isArray(res) ? res : []);
        });
    }, []);

    const save = (newRows) => {
const data = { functions: newRows };
        const buildExpression = (row) => row.value || '';

        const dataServer = {
            action_type: 'function',
            functions: newRows.map(({ autoOpen: _ao, ...row }) => ({
                index: row.index,
                variable_id: row.variable ? row.variable.id : null,
                functions: buildExpression(row),
                parameters: (row.params || []).map(p => {
                    const val = p.value ?? '';
                    if (val !== '' && !isNaN(val) && String(val).trim() !== '') return { ...p, value: Number(val) };
                    return p;
                }),
            })),
        };
        updateBlockData(id, data, dataServer);
    };

    const addFunction = () => {
        const newRows = [...rows, { index: rows.length, value: '', autoOpen: true }];
        save(newRows);
    };

    const setValue = (index, field, value) => {
        const newRows = rows.map((row) => (row.index === index ? { ...row, [field]: value } : row));
        save(newRows);
    };

    const updateRow = (index, updates) => {
        const newRows = rows.map((row) => (row.index === index ? { ...row, ...updates } : row));
        save(newRows);
    };

    const deleteValue = (index) => {
        const newRows = rows
            .filter((row) => row.index !== index)
            .map((row, idx) => ({ ...row, index: idx }));
        save(newRows);
    };

    const moveFunction = (indexStart, indexDestination) => {
        let newRows = [...rows];
        const [moved] = newRows.splice(indexStart, 1);
        newRows.splice(indexDestination, 0, moved);
        newRows = newRows.map((row, idx) => ({ ...row, index: idx }));
        save(newRows);
    };

    const functionsRow = { setValue, updateRow, deleteValue, move: moveFunction, functions: availableFunctions };

    return (
        <>
            <TitleBlock title="Function" titleInput="Function name" name={name} id={id} />
            <AreaList title="Function" buttonLabel="Add Function" maxHeight="550px" onClickButton={() => addFunction()}>
                <AreaListData data={rows} ComponentRow={FunctionRow} FunctionsRow={functionsRow} />
            </AreaList>
        </>
    );
}

export default FormFunction;
